// src/cert/iatf16949.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const IATF16949 = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>IATF 16949 प्रमाणन</h1>
                <p>ऑटोमोटिव्ह गुणवत्ता व्यवस्थापन प्रणाली (Automotive Quality Management System)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>IATF 16949 म्हणजे काय?</h2>
                    <p>

                        IATF 16949, specified by The International Automotive Task Force (IATF), defines the QMS standards specifically for the Automotive industry. An organization needs to achieve this certification through a 3rd party auditor.

                        IATF 16949 defines the criteria for an automotive-based QMS with the goal to become 3rd party registered. It can be used by any supplier, large or small, and should be applied throughout the automotive supply chain. In fact, there over 65,000 suppliers worldwide which are currently certified to ISO/TS 16949.
                        Overview
                        IATF 16949 is a quality management standard for the automotive industry, developed by the International Automotive Task Force (IATF). It harmonizes the requirements of various automotive manufacturers and suppliers, ensuring consistency and efficiency in the supply chain.
                        Purpose
                        IATF 16949 certification aims to:
                        1. Improve product quality
                        2. Enhance customer satisfaction
                        3. Reduce defects and waste
                        4. Increase efficiency and productivity
                        5. Ensure supply chain reliability
                        Key Requirements
                        1. Quality Management System (QMS)
                        2. Risk-based thinking
                        3. Process approach
                        4. Continuous improvement
                        5. Supply chain management
                        6. Documentation and record-keeping
                        7. Internal audits and management review
                        8. Corrective action and preventive action
                        Benefits
                        1. Global recognition and acceptance
                        2. Improved product quality and reliability
                        3. Enhanced customer satisfaction
                        4. Reduced defects and warranty claims
                        5. Increased efficiency and productivity
                        6. Better supply chain management
                        7. Competitive advantage
                        8. Compliance with automotive industry requirements
                        Industry Applicability
                        IATF 16949 applies to:
                        1. Automotive manufacturers
                        2. Tier 1, 2, and 3 suppliers
                        3. Component manufacturers
                        4. Raw material suppliers
                        5. Service providers (e.g., logistics, packaging).
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>जागतिक ऑटोमोटिव्ह पुरवठादार साखळीत प्रवेश</li>
                        <li>उत्पादन दोष, परतावा आणि दंड कमी होतात</li>
                        <li>प्रक्रिया सुव्यवस्थित होऊन खर्च कमी होतात</li>
                        <li>ग्राहक (OEM) समाधान वाढते</li>
                        <li>जोखीम व्यवस्थापन आणि सातत्यपूर्ण गुणवत्ता</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>IATF 16949 साठी अर्ज करा</h2>
                    <ApplyForm certification="IATF 16949" />
                </section>
            </div>
        </div>
    );
};

export default IATF16949;